/**
 * Session idle / activity thresholds.
 *
 * Ordering invariant:
 *   warning (25m) < hard-logout (29m) < Auth0 refresh-token idle lifetime (30m)
 * The ~1 minute buffer under the RT idle lifetime guarantees the warning fires
 * while the refresh token is still alive, so "Stay logged in" can always
 * exchange it. If the idle policy changes, these values and the Auth0 RT idle
 * lifetime must move together.
 */

const MINUTE_MS = 60_000;

export const INACTIVITY_WARNING_MS = 25 * MINUTE_MS;
export const INACTIVITY_LOGOUT_MS = 29 * MINUTE_MS;

// How often the inactivity monitor checks `now - lastActivity`. Polling a
// wall-clock timestamp (instead of a single setTimeout) survives background-tab
// throttling and laptop sleep, and reads cross-tab activity for free.
export const INACTIVITY_POLL_MS = 30_000;

// One activity-timestamp write per second is plenty to track idleness while
// keeping the noisy scroll/keydown handlers cheap.
export const ACTIVITY_THROTTLE_MS = 1000;

// Intentional, user-driven activity only. `mousemove` is intentionally excluded
// so stray cursor jitter on a walked-away machine doesn't keep the session
// alive; tab focus is excluded because the requirement asks for real activity.
export const ACTIVITY_EVENTS = ['click', 'keydown', 'pointerdown', 'scroll'] as const;
